import { createContext } from 'react';
import { DataBridge } from 'expertli-lib/dist/models';

export const DataBridgeContext = createContext<DataBridge>(null);
